'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Image, Link } from '@akinon/next/components';
import { Button } from '@theme/components';
import { useLocalization } from '@akinon/next/hooks';

export default function BlogSlider({ slides }: { slides: any }) {
  const { t } = useLocalization();

  return (
    <Swiper
      modules={[Pagination, Autoplay]}
      style={
        {
          '--swiper-pagination-bottom': '1.5rem',
          '--swiper-pagination-bullet-inactive-color': '#FFFFFF',
          '--swiper-pagination-bullet-inactive-opacity': '0.5',
          '--swiper-pagination-color': '#FFFFFF'
        } as unknown
      }
      autoplay={{
        delay: 5000,
        disableOnInteraction: false
      }}
      loop={true}
      pagination={{
        clickable: true
      }}
      slidesPerView={1}
    >
      {slides?.map((item, i) => (
        <SwiperSlide key={i}>
          <Link href={item.value.banner_url} className="relative block">
            <Image
              src={item.kwargs.value.banner_mobile_image.url}
              alt={item.value.title}
              fill
              imageClassName="object-cover"
              aspectRatio={768 / 960}
              draggable={false}
              sizes="640px"
              className="block md:hidden w-full"
              priority={i === 0}
            />
            <Image
              src={item.kwargs.value.banner_image.url}
              alt={item.value.title}
              fill
              imageClassName="object-cover"
              aspectRatio={1920 / 594}
              draggable={false}
              sizes="1920px"
              className="hidden md:block w-full"
              priority={i === 0}
            />
            <div className="absolute inset-0 flex flex-col items-start justify-center text-left ps-5 lg:ps-[5%]">
              {item?.value?.title && (
                <div className="text-2xl lg:text-[44px] font-medium text-white mb-8 max-w-[280px] lg:max-w-[500px] leading-none">
                  {item?.value?.title}
                </div>
              )}

              <Button>{t('common.blog.read_article')}</Button>
            </div>
          </Link>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
